import ElectricBoltOutlinedIcon from '@mui/icons-material/ElectricBoltOutlined';
import React from 'react';
import { useTranslation } from '@hooks/useTranslation';

interface DashboardHeaderProps {
  title?: string;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
}) => {
  // Sprint 28, story-144. Decision 2 (docs/architecture.md "## Sprint 28") — own default via
  // `menu.*` (reused, not forked); a caller with a different title still overrides via the prop.
  const tMenu = useTranslation('menu');
  const resolvedTitle = title ?? tMenu.dashboard;
  return (
    <div className="flex items-center gap-2">
      <ElectricBoltOutlinedIcon
        sx={{ fontSize: 28 }}
        className="text-orange-400 dark:text-orange-300"
      />
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
        {resolvedTitle}
      </h1>
    </div>
  );
};
